import PropTypes from 'prop-types';
import React, { Component } from 'react';
import PdfFooter from './Footer';
import PdfHeader from './Header';
import { getPdf } from './pdfs';
import './styles.css';
class PdfViewer extends Component {
	render() {
		const { match, history, scenario } = this.props;
		const data = getPdf(scenario, match.params.pdfID);
		return (
			<div className="pdf-viewer-body">
				<PdfHeader>
					<div>
						<span>{data.name}</span>
					</div>
					<div>
						<a href={`${data.pdf}`} download={data.name}>
							DOWNLOAD
						</a>
						<span
							onClick={() => {
								history.goBack();
							}}
						>
							CLOSE
						</span>
					</div>
				</PdfHeader>
				<div className="pdf-viewer">
					<object className="pdf-viewer-content" data={`${data.pdf}#toolbar=0&navpanes=0&scrollbar=0`} type="application/pdf">
						<embed src={`${data.pdf}#toolbar=0&navpanes=0&scrollbar=0`} type="application/pdf" />
					</object>
					<PdfFooter>
					</PdfFooter>
				</div>
			</div>
		);
	}
}

PdfViewer.propTypes = {
	match: PropTypes.shape({
		params: PropTypes.shape({ pdfID: PropTypes.string.isRequired })
	})
};

export default PdfViewer;
